module.exports = __webpack_public_path__ + "img/radiologie.caea520a.png";